<template>
  <soha-modal
    :id="modalId"
    :title="$t(`${I18nPrefix}TITLE`)"
    @hide="clearModalData"
    @show="getRejectReasons"
  >
    <template #activator />
    <template #body>
      <soha-page-loading v-if="loading" />
      <div v-else>
        <soha-multi-select
          v-model="selectedReason"
          class="w-100 my-3"
          name="reasonRejection"
          :error="selectedReasonError"
          :placeholder="$t(`${I18nPrefix}REASON_REJECTION`)"
          :options="rejectReasons"
          always-open
        />
        <soha-text-area
          v-model="description"
          name="description"
          class="w-100 my-3"
          :placeholder="$t(`${I18nPrefix}DESCRIPTION`)"
        />
      </div>
    </template>
    <template #footer>
      <soha-button
        class="w-100"
        name="sendToArchive"
        variant="primary"
        :text="$t(`${I18nPrefix}SEND`)"
        :loading="btnLoading"
        @btn-click="stepId ? sendAllResumesStepToArchive() : sendToArchive()"
      />
    </template>
  </soha-modal>
</template>

<script>
import ApiService from "@/core/services/api.service";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";
import { mapGetters } from "vuex";
const ArchiveStepId = "1";
export default {
  name: "ResumeModalSendToArchive",

  mixins: [ValidationMixin, UIMixin],

  props: {
    resumeId: {
      type: [String, Number],
      default: null,
    },
    jobId: {
      type: [String, Number],
      default: null,
    },
    stepId: {
      type: [String, Number],
      default: null,
    },
    modalId: {
      type: String,
      default: "sendToArchive",
    },
  },

  emits: ['sendToArchive', 'closeModal'],

  data() {
    return {
      I18nPrefix: "COMPONENTS.RESUME.RESUME_SEND_TO_ARCHIVE_MODAL.",
      loading: false,
      btnLoading: false,
      selectedReason: [],
      description: null,
      rejectReasons: [],
      selectedReasonError: null,
    };
  },

  methods: {
    sendToArchive() {
      this.selectedReasonError = this.validateField(
        this.selectedReason,
        this.$t(`${this.I18nPrefix}REASON_REJECTION`),
        0,
        "select"
      );
      if (!this.selectedReasonError) {
        this.btnLoading = true;
        ApiService.put(`api/v2/resumes/${this.resumeId}/steps`, {
          newStepId: ArchiveStepId,
          rejectReasons: {
            description: this.description,
            ids: this.selectedReason,
          },
        }).then(({ data }) => {
          if (+data.code === 211) {
            this.successToast(data.message);
            this.$emit("sendToArchive", this.selectedReasonObject);
            this.$modal.hide(this.modalId);
          } else {
            this.errorToast(data.message);
          }
          this.btnLoading = false;
        });
      }
    },

    sendAllResumesStepToArchive() {
      this.selectedReasonError = this.validateField(
        this.selectedReason,
        this.$t(`${this.I18nPrefix}REASON_REJECTION`),
        0,
        "select"
      );
      if (this.selectedReasonError) return;
      this.btnLoading = true;
      ApiService.post(
        `/api/v2/jobs/${this.jobId}/steps/${this.stepId}/resumes/transfer/1`,
        {
          newStepId: ArchiveStepId,
          rejectReasons: {
            description: this.description,
            ids: this.selectedReason,
          },
        }
      ).then(({ data }) => {
        if (data.code == 204) {
          this.successToast(data.message);
          this.$emit("sendToArchive", this.selectedReasonObject);
          this.$modal.hide(this.modalId);
        } else {
          this.errorToast(data.message);
        }
        this.btnLoading = false;
      });
    },

    getRejectReasons() {
      this.loading = true;
      ApiService.get(`api/v2/companies/${this.companyId}/reject-reasons`).then(
        ({ data }) => {
          if (!data.code) {
            this.rejectReasons = data.map((reason) => {
              return {
                id: reason.id,
                text: reason.name,
              };
            });
            this.loading = false;
          } else {
            this.errorToast(data.message);
          }
        }
      );
    },

    clearModalData() {
      this.selectedReason = [];
      this.description = null;
      this.$emit("closeModal");
    },
  },

  computed: {
    ...mapGetters(["companyId"]),

    selectedReasonObject() {
      return this.rejectReasons.filter(reason => {
        return this.selectedReason.includes(reason.id);
      })
    }
  },
};
</script>

<style scoped></style>
